module.exports = __webpack_public_path__ + "static/media/215-falkland-islands.9dc118d2.svg";